import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  /**
   * Intercepts and handles an HttpRequest or HttpResponse.
   *
   * @param request An outgoing HTTP request with an optional typed body.
   * @param next HttpHandler parameter is the next interceptor in the chain.
   * @returns A representation of any set of values over any amount of time.
   * This is the most basic building block of RxJS.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request);
  }
}
